// extracted by mini-css-extract-plugin
module.exports = {"label-chip":"LabelEdit_label-chip__3hsS9","edit":"LabelEdit_edit__3lYvi","edit-icon":"LabelEdit_edit-icon__2cYHB","next-to-previous":"LabelEdit_next-to-previous__2AyO0"};